export default __webpack_public_path__ + "static/media/dullingblow1.328a1fe0.png";